import { createContext } from 'react';
import { BaseLogger } from '../../logger/BaseLogger';

export interface LoggerContextValues {
  logger: BaseLogger;
}

export const LoggerContext = createContext<LoggerContextValues | undefined>(undefined);
